import { getEmail, getDisplayGlobally, getFriendlyFromName, getResolvedFromName, getSendFromEmail
// @ts-expect-error module not typed
} from 'conversations-internal-schema/connected-email-account/operators/connectedEmailAccountGetters';
import { getId, getInstanceDeliveryIdentifier, getIsActive } from 'conversations-thread-data/channel-instances/public/operators';
import { getDeliveryIdentifierValue } from 'conversations-message-history/common-message-format/operators/deliveryIdentifierGetters';
import I18n from 'I18n';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
export const getChannelInstanceOptions = ({
  connectedAccounts,
  channelInstances,
  defaultSendFrom
}) => {
  if (!channelInstances) return [];
  const dropdownOptions = channelInstances.reduce((accumulator, instance) => {
    const deliveryIdentifier = getInstanceDeliveryIdentifier(instance);
    const address = getDeliveryIdentifierValue(deliveryIdentifier);
    const disabled = !getIsActive(instance);
    const connectedAccount = connectedAccounts && connectedAccounts.find(account => {
      const connectedEmail = getEmail(account);
      return connectedEmail && connectedEmail.toLowerCase() === address.toLowerCase();
    });
    if (connectedAccount && !getDisplayGlobally(connectedAccount)) {
      return accumulator;
    }
    const friendlyName = connectedAccount ? getResolvedFromName(connectedAccount) || getFriendlyFromName(connectedAccount) : null;
    const displayAddress = connectedAccount && getSendFromEmail(connectedAccount) || address;
    const text = friendlyName ? `${friendlyName} ( ${displayAddress} )` : displayAddress;
    accumulator.push({
      id: getId(instance),
      disabled,
      dropdownText: displayAddress,
      text,
      value: address,
      badge: address === (defaultSendFrom === null || defaultSendFrom === void 0 ? void 0 : defaultSendFrom.value) ? /*#__PURE__*/_jsx(Badge, {
        use: "pantera",
        children: I18n.text('composer-ui.metadata-editor.defaultSendFrom.badge')
      }) : undefined
    });
    return accumulator;
  }, []);

  // sort alphabetically w/ disabled options last and options with badges at the top
  return dropdownOptions.sort((optionA, optionB) => {
    if (optionA.badge && !optionB.badge) {
      return -1;
    }
    if (!optionA.badge && optionB.badge) {
      return 1;
    }
    if (optionA.disabled === optionB.disabled) {
      return optionA.dropdownText < optionB.dropdownText ? -1 : 1;
    }
    return optionA.disabled ? 1 : -1;
  });
};